<template>
  <v-card>
    <v-card-text>
      <v-tabs v-model="tabs">
        <v-tab>Individual Account</v-tab>
        <v-tab>Business Account</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <sign-up-single-user-account @created="handleCreated" />
        </v-tab-item>
        <v-tab-item>
          <sign-up-business-account @created="handleCreated" />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import SignUpSingleUserAccount from '@/components/SignUpSingleUserAccount'
import SignUpBusinessAccount from '@/components/SignUpBusinessAccount'

export default {
  name: 'SignUp',
  components: { SignUpBusinessAccount, SignUpSingleUserAccount },
  data: function () {
    return {
      tabs: null
    }
  },
  methods: {
    handleCreated() {
      const { host, protocol } = window.location
      window.top.location = `${protocol}//${host}/login`
    }
  }
}
</script>
<style lang="scss">
body {
  background-color: transparent;
}
.theme--light.v-application {
  background-color: transparent;
}
</style>
